export default "__VITE_ASSET__fb03c2fc__"